import { api } from 'app/config/apiConfig';
import { VerificationDocument } from '../model/types';

export interface UpdateVerificationPhotoArgs {
  verificationPhotoId: string;
  fileStatus: 'approved' | 'rejected';
  note?: Nullable<string>;
}

export const updateVerificationPhotoApi = api.injectEndpoints({
  endpoints: (builder) => ({
    updateVerificationPhoto: builder.mutation<VerificationDocument, UpdateVerificationPhotoArgs>({
      query: ({ verificationPhotoId, ...body }) => ({
        url: `/verification-photos/${verificationPhotoId}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['VerificationDocuments', 'Users'],
    }),
  }),
});

export const { useUpdateVerificationPhotoMutation } = updateVerificationPhotoApi;
